// Sentry must be imported first, before any other code
import "./instrument";

import ReactDOM from "react-dom/client";
import "@/css/global.css";
import { Provider } from "react-redux";
import { persistor, store } from "@/store";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientConfig, QueryClientProvider } from "@tanstack/react-query";
import { VersionedApp } from "@/components/contexts/VersionedApp";
import * as Sentry from "@sentry/react";
import React from "react";
import { recordPreloadError } from "@/lib/module-recovery";
import { shouldRetryQuery } from "@/lib/auth-response";

window.addEventListener("vite:preloadError", (event) => {
    recordPreloadError((event as Event & { payload: unknown }).payload);
});

console.log("API URL:", import.meta.env.VITE_API_URL);
console.log("App Version:", __APP_VERSION__);

const queryClientOptions: QueryClientConfig = {
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000, // 30 seconds - data stays fresh for 30 seconds
            gcTime: 5 * 60 * 1000, // 5 minutes - cache persists for 5 min
            // refetchOnWindowFocus: true, // Don't refetch on window focus (rely on SignalR)
            // refetchOnMount: true, // Do refetch on mount for fresh data
            retry: shouldRetryQuery,
        },
    },
};

const queryClient = new QueryClient(queryClientOptions);

const AppWrapper = import.meta.env.MODE === "production" ? Sentry.ErrorBoundary : React.Fragment;

ReactDOM.createRoot(document.getElementById("root")!).render(
    // <React.StrictMode>
    <AppWrapper fallback={<div>An error has occurred</div>} showDialog>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <QueryClientProvider client={queryClient}>
                    <VersionedApp />
                </QueryClientProvider>
            </PersistGate>
        </Provider>
    </AppWrapper>
    // </React.StrictMode>
);
